import { ArlFormDataService, arlTableDataArlForm } from '../arl-form-data.service';
import { combineLatest } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';
import {
    CalcAccountsReceivableLedgerNettoAmountWithAllowances, financialRound,
} from '../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import {
    CalcAccountsReceivableLedgerBruttoBaseCostWithAllowancesCharges,
    CalcAccountsReceivableLedgerNettoBaseCostWithAllowancesCharges,
    CalcAccountsReceivableLedgerNettoBaseCostWithOnlyCharges,
} from '../arl-calculation.helper';

export const getAmountFromForm$ = (form: arlTableDataArlForm, arlFormDataService: ArlFormDataService, config?: {ignoreParentAllowanceCharges?: boolean})=> {
    return combineLatest([
        arlFormDataService.parentBaseCostAllowances$(form.value.Id),
        form.controls.InheritFromChildren.valueChanges.pipe(startWith(null)),
        form.controls.Quantity.valueChanges.pipe(startWith(null)),
        form.controls.BaseCost.valueChanges.pipe(startWith(null)),
        form.controls.BaseCostGross.valueChanges.pipe(startWith(null)),
        form.controls.SalaryBaseCost.valueChanges.pipe(startWith(null)),
        form.controls.BaseCostAllowances.valueChanges.pipe(startWith(null)),
        form.controls.Type.valueChanges.pipe(startWith(null)),
        form.controls.CostAmount.valueChanges.pipe(startWith(null)),
        form.controls.FixedPrices.valueChanges.pipe(startWith(null)),
        // calculatedAmount.valueChanges.pipe(startWith(null)),
    ]).pipe(
        map(([parentAllowances]) => {
            const formValue = form.getRawValue();
            if (config?.ignoreParentAllowanceCharges) {
                parentAllowances = [];
            }


            const amount = CalcAccountsReceivableLedgerNettoAmountWithAllowances(formValue, parentAllowances);

            const baseCostWithArlCharges = CalcAccountsReceivableLedgerNettoBaseCostWithOnlyCharges(formValue, parentAllowances);
            const baseCostWithArlAllowanceCharges = CalcAccountsReceivableLedgerNettoBaseCostWithAllowancesCharges(formValue, parentAllowances);
            const baseCostGrossWithArlAllowanceCharges = CalcAccountsReceivableLedgerBruttoBaseCostWithAllowancesCharges(formValue, parentAllowances);

            const baseCostSalaryRatio = formValue.BaseCost ? formValue.SalaryBaseCost / formValue.BaseCost : 0;

            const salaryBaseCostWithArlCharges = financialRound(baseCostWithArlCharges * baseCostSalaryRatio);
            const salaryBaseCostWithArlAllowanceCharges = financialRound(baseCostWithArlAllowanceCharges * baseCostSalaryRatio);


            return {
                amount,
                baseCostWithArlCharges,
                baseCostWithArlAllowanceCharges,
                baseCostGrossWithArlAllowanceCharges,
                salaryBaseCostWithArlCharges,
                salaryBaseCostWithArlAllowanceCharges,
                costAmount: (formValue.CostAmount || 0) * (formValue.Quantity || 0),
            }
        }),
        // tap((a) => console.log('amount$', a, e)),
        shareReplay({ bufferSize: 1, refCount: true }),
    );
}
